import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import DialogList from 'src/dialogs';
import { useArServiceCtx } from '../AccountsReceivableServiceContext';

interface IReportOptionsDialogProps {
    dialogName: string;
    handleReport?: (category: string, subcategory: string) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    reportTypes?: Array<{ value: string | number, label: string }>;
    sortOptions?: Array<{ value: string | number, label: string }>;
    parentType?: number;
    offices?: Array<{value: number | string, label: string}>;
}

// usp_ARDeposits/usp_LHDeposits/usp_DDDeposits parse beg_date/end_date with
// try_convert(datetime2, @beg_date, 101) - MM/DD/YYYY - while the native <input type="date">
// fields this dialog uses always emit ISO (YYYY-MM-DD).
const isoDateToMMDDYYYY = (isoDate: string) => {
    if (!isoDate) {
        return '';
    }
    const [year, month, day] = isoDate.split('-');
    return `${month}/${day}/${year}`;
};

const ReportOptionsDialog = (props: IReportOptionsDialogProps) => {
    const { register, errors, getValues } = useForm();
    const { getDepositReport } = useArServiceCtx();
    // usp_ARDeposits/usp_LHDeposits/usp_DDDeposits's date filter is a no-op when both dates are
    // blank - with ~440k qualifying AR_DETAIL rows, an unfiltered request risks the same
    // unbounded-report problem the SSRS gotchas memory warns about, so require a date range.
    const [dateRangeError, setDateRangeError] = useState<string>('');

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    const OKClicked = async () => {
        const data = getValues();
        const reportOptions = data?.reportOptions;

        if (!reportOptions?.beginDate || !reportOptions?.endDate) {
            setDateRangeError('Beginning Date and Ending Date are both required.');
            return;
        }
        setDateRangeError('');

        await getDepositReport({
            reportName: reportOptions?.reportType,
            clientNumber: reportOptions?.clientNumber,
            beginDate: isoDateToMMDDYYYY(reportOptions?.beginDate),
            endDate: isoDateToMMDDYYYY(reportOptions?.endDate),
            depositNumber: reportOptions?.depositNumber
        });

        props.handleReport?.(reportOptions?.reportType, reportOptions?.depositNumber);
        props.hideDialog();
    };

    return (
        <Dialog title="Report Options" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <RHFSelect
                        label="Report Type"
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        name={`reportOptions.reportType`}
                        options={!!props?.reportTypes ? props.reportTypes : [
                            { value: '1', label: 'Other Parameters - Invoice Date' },
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                    <RHFInputBox
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Client Number"
                        labelOnLeft={true}
                        name={`reportOptions.clientNumber`}
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '60%' }}
                    />
                    <RHFInputBox
                        label="Beginning Date"
                        labelOnLeft={true}
                        labelStyle={{ width: '15rem'}}
                        name={`reportOptions.beginDate`}
                        type="date"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                    <RHFInputBox
                        label="Ending Date"
                        labelOnLeft={true}
                        labelStyle={{ width: '15rem'}}
                        name={`reportOptions.endDate`}
                        type="date"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                    <RHFInputBox
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Deposit Number"
                        labelOnLeft={true}
                        name={`reportOptions.depositNumber`}
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '60%' }}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
            {dateRangeError && (
                <div style={{ color: 'red', textAlign: 'center', marginTop: '0.5rem' }}>
                    {dateRangeError}
                </div>
            )}
        </Dialog>
    );
};

export default ReportOptionsDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/dialogs/ReportOptionsDialog.tsx